import { render } from "./HomePage.vue?vue&type=template&id=34b63ca2&scoped=true&ts=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=34b63ca2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b63ca2"]])

export default __exports__